import { Dispatch, SetStateAction } from 'react';
import { Desktop, Mobile } from '../../../App';
import { BACKOFFICE_NAME, USDT } from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, H4, P1 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';

import { Checkbox } from '../Checkbox/Checkbox';

import { useTranslation } from 'react-i18next';
import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';
import { UserVirtualOfficeLicence } from '../../../views/Settings/settings.types';

interface VirtualOfficePlanProps {
  selected: any;
  setSelected: Dispatch<SetStateAction<any>>;
}

export const VirtualOfficePlan = ({
  selected,
  setSelected
}: VirtualOfficePlanProps) => {
  const { t } = useTranslation('settings');

  return (
    <div>
      <P1 bold mb='20' mt='20' caps>
        Add {BACKOFFICE_NAME} SUBSCRIPTION:
      </P1>

      <VirtualOfficeSubscriptionStyled
        onClick={() => setSelected(selected?.plan)}>
        <div>
          <Flexed between>
            <Flexed center>
              <Checkbox
                margin='0 20px 0 0'
                size='38'
                onClick={() => setSelected(selected?.plan)}
                checked={true}
              />
              <div>
                <H3>{selected?.name}</H3>
              </div>
            </Flexed>
            <Flexed alignEnd column>
              <Desktop>
                <H4>
                  {selected?.price} {USDT}+VAT+FEE
                </H4>
              </Desktop>
              <Mobile>
                <H3>
                  ${selected?.price} {USDT}+VAT+FEE
                </H3>
              </Mobile>
              {selected?.save && (
                <CaptionText bold color={color.colors.secondary100}>
                  {t('virtual_office.plans.save')} {selected?.save}%
                </CaptionText>
              )}
            </Flexed>
          </Flexed>
        </div>
      </VirtualOfficeSubscriptionStyled>
    </div>
  );
};
